//
export default [
    'g_user.hr_employee',
    'pos_cash_desk.g_branch_office',
    'payments',
    'pos_detail_customer_receivable_payments.sl_customer_account_movement.sl_type_customer_account_movement',
    'pos_detail_customer_receivable_payments.sl_customer_receivable.sl_sale_invoice',
    'pos_detail_customer_receivable_payments.sl_customer_receivable.sl_sale_debit_note',
    'pos_detail_customer_receivable_payments.sl_customer_receivable.sl_customer_branch_offices',
    'sl_customer.sl_customer_account',
    'sl_customer.sl_ground_seller.hr_employee.g_user',
    'sl_ground_seller_payment_record.sl_customer.pch_payment_condition',
    'sl_ground_seller_payment_record.sl_customer.sl_customer_account',
    'sl_ground_seller_payment_record.sl_detail_ground_seller_payment_records.sl_customer_account_receivable.sl_sale_invoice',
    //'sl_ground_seller_payment_record.sl_detail_ground_seller_payment_records.sl_customer_account_receivable.sl_sale_debit_note',
    'sl_ground_seller_payment_record.sl_ground_seller.hr_employee',
]